import React from "react";
import { Link, useLocation } from "react-router-dom";
import Google from "../assets/images/google-icon.svg";

import { useDispatch } from "react-redux";
import { socialLogin } from "../features/auth/authActions";
import { useGoogleLogin } from "@react-oauth/google";

import { toast } from "react-toastify";

export default function LoginFbAuth() {
  const dispatch = useDispatch();
  const location = useLocation();

  // Determine if we're on sign-up or sign-in page
  const isSignUpPage = location.pathname.includes("/sign-up");
  const buttonText = isSignUpPage ? "Sign Up with Google" : "Sign In with Google";

  // Get the current origin (e.g., http://localhost:3000 or https://yourdomain.com)
  const redirectUri = window.location.origin;

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log("Access Token:", tokenResponse.access_token);

      const accessToken = tokenResponse.access_token;
      dispatch(socialLogin({ provider: "google", access_token: accessToken }));

      // Usually you send this access token to your backend for further processing
    },
    onError: (error) => {
      console.error("Google Login Error:", error);
      if (error.error === "redirect_uri_mismatch") {
        toast.error("OAuth configuration error. Please contact support.");
        console.error("Redirect URI mismatch. Current origin:", redirectUri);
        console.error("Please add this redirect URI to Google Cloud Console:", redirectUri);
      } else {
        toast.error("Login Failed");
      }
    },
    flow: "implicit", // or 'auth-code' if you want to do server-side exchange
    redirectUri: redirectUri, // Explicitly set redirect URI
  });

  return (
    <Link onClick={() => handleGoogleLogin()} className="cutsom-bttn login-btn">
      <img src={Google} alt="" /> {buttonText}
    </Link>
  );
}
